import { FC } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
} from "@mui/material";

export interface CustomMoveLocationsDialogProps
  extends Omit<
    DialogProps,
    "onClose" | "open" | "style" | "inputValue" | "handler"
  > {
  children: React.ReactNode;
  description?: string;
  onConfirm: (onClose: () => void, value?: string) => void;
  onClose: () => void;
  open?: boolean;
  inputValue?: string;
  handler?: (value: string) => void;
  cancelText?: string;
  confirmText?: string;
  confirmButtonDisabled?: boolean;
}

export const CustomMoveLocationsDialog: FC<CustomMoveLocationsDialogProps> = (
  props,
) => {
  const {
    title,
    sx,
    onConfirm,
    onClose,
    children,
    open,
    cancelText = "Cancel",
    confirmText = "Save",
    confirmButtonDisabled = false,
    ...rest
  } = props;

  return (
    <Dialog onClose={onClose} {...rest} sx={sx || {}} open={open || false}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          sx={{ color: "#8ACEFF" }}
          data-testid="cancel-button"
        >
          {cancelText}
        </Button>
        <Button
          onClick={() => onConfirm(onClose, "confirm")}
          variant="contained"
          sx={{
            backgroundColor: "#8ACEFF",
            color: "#00344E",
          }}
          disabled={confirmButtonDisabled}
          data-testid="confirm-button"
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
